//
//
//
//
//

export default {
  components: {
  },
  directives: {
  },
  data() {
    return {
    }
  },
  methods: {
      getUserInfo(opid){
        var app = this;
        var obj = {
            headers: {
              token: localStorage.getItem("token"),
              opid: opid
            }
        };
        let openid = localStorage.getItem('openid')
        this.$http.get("api/v1/wechat/need_update_wx?openid=" + openid, obj).then().cheat(res=>{
            console.log(res)
        })
      }
  },
  created() {
    //this.account = this.$route.params.account
    this.opid = localStorage.getItem("userid");
    this.getUserInfo(this.opid);
  }
}



// WEBPACK FOOTER //
// ./src/components/promptUpdate.vue